import { Box } from "@jewlr/storybook/core"
import loadable from "@loadable/component"
import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"
import styled from "styled-components"

import ShipInfoLoading from "areas/product/jewlr/loaders/ship-info-loading"
import { retry } from "helpers/application"

import ShipDetails from "./ship-details"
import Title from "./title"

const InstantGiftPreview = loadable(() =>
  retry(() => import("areas/instant-gift/explained/modal"))
)

const Container = styled(Box).attrs({
  bg: { _: "#D7F3B9", tablet: "grey.200" },
})`
  margin-bottom: 18px;
  padding: 16px 20px;
  text-align: center;
  ${(props) => props.theme.mediaQueries.tablet`
    background-color: ${props.theme.colors.grey[4]};
    padding: 30px 24px;
  `}
`

const InternalShipping = ({ ship, wizardLoading }) => {
  if (!ship || wizardLoading) {
    return (
      <Container alignItems="center" display="flex" minHeight="130px">
        <Box width="100%">
          <ShipInfoLoading />
        </Box>
      </Container>
    )
  }

  // if ship.ship_days <= 2
  // <>
  //   <Typography color="black" fontSize="16px" mb="3px">
  //     Custom made for you in
  //   </Typography>
  //   <Flex alignItems="center" justifyContent="center">
  //     <Box
  //       as="img"
  //       mr={1}
  //       src={require("images/icons/quick_ship_green.svg")}
  //       height="24px"
  //       width="auto"
  //     />
  //     <Typography color="greenDarker" fontSize="30px" light>
  //       {ship.ship_days < 1 ? "1" : ship.ship_days} DAY
  //       {ship.ship_days > 1 && "S"}
  //     </Typography>
  //   </Flex>
  // </>
  return (
    <Container id="shipping_options_container">
      <Title />
      <ShipDetails />
      <InstantGiftPreview />
    </Container>
  )
}

const mapStateToProps = (state) => {
  return {
    ship: state.wizard.shipping.main,
    wizardLoading: state.wizard.loading,
  }
}

const mapDispatchToProps = () => {
  return {}
}

InternalShipping.propTypes = {
  ship: PropTypes.object,
  wizardLoading: PropTypes.string,
}

const Shipping = connect(mapStateToProps, mapDispatchToProps)(InternalShipping)

export default Shipping
